import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ViewProjectInfoModalPage } from './view-project-info-modal.page';

const routes: Routes = [
  {
    path: '',
    component: ViewProjectInfoModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ViewProjectInfoModalPage]
})
export class ViewProjectInfoModalPageModule { }
